import type { ClaimKind } from "@patent-studio/api-types";
import { cn } from "@/lib/utils";

/** The type a claim's words are set in: an independent claim reads heavier than its dependents. */
const KIND = {
  independent: "text-[14px] leading-[1.45] font-bold",
  dependent: "text-[13px] leading-[1.45] font-medium",
} as const;

/** An element and a sub-element step in under a rule, as the design indents them. */
const DEPTH = [
  "",
  "mt-[3px] ml-[14px] border-l-2 border-border-subtle pl-[11px]",
  "mt-0.5 ml-8 border-l-2 border-border-subtle pl-[11px]",
] as const;

/** How one line of a claim is set, read-only or being written: its kind's type, and its depth's indent. */
export function claimLineStyle(kind: ClaimKind, depth: number): string {
  return cn(
    KIND[kind],
    DEPTH[Math.min(depth, DEPTH.length - 1)],
    kind === "independent" && depth > 0 && "font-semibold",
  );
}
